import scroll from './src/';

export default scroll;


// WEBPACK FOOTER //
// ./src/components/scroll/index.js